var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 2.28571C0.600098 1.94472 0.747597 1.6177 1.01015 1.37658C1.2727 1.13546 1.62879 1 2.0001 1C2.3714 1 2.7275 1.13546 2.99005 1.37658C3.2526 1.6177 3.4001 1.94472 3.4001 2.28571C3.4001 2.62671 3.2526 2.95373 2.99005 3.19485C2.7275 3.43597 2.3714 3.57143 2.0001 3.57143C1.62879 3.57143 1.2727 3.43597 1.01015 3.19485C0.747597 2.95373 0.600098 2.62671 0.600098 2.28571ZM1.3001 5.28571H2.7001C2.82843 5.28571 2.93343 5.38214 2.93343 5.5V12.7857C2.93343 12.9036 2.82843 13 2.7001 13H1.3001C1.17176 13 1.06676 12.9036 1.06676 12.7857V5.5C1.06676 5.38214 1.17176 5.28571 1.3001 5.28571Z",
    fill: "#858585",
    stroke: "#858585",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.713e2fab.svg";
export { ForwardRef as ReactComponent };